<template>
  <v-btn
    :small="small"
    :disabled="disabled"
    color="dark"
    text
    class="font-weight-medium subheading"
    @click="evt => $emit('click', evt)"
  >
    <slot>Cancel</slot>
  </v-btn>
</template>

<script>
export default {
  props: {
    small: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false }
  }
}
</script>

<style lang="scss" scoped>
* {
  text-transform: none !important;
}
</style>
